var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.356 26.4216C50.3225 26.4216 51.106 27.2051 51.106 28.1716V49.1716C51.106 50.1381 50.3225 50.9216 49.356 50.9216H7.35596C6.38946 50.9216 5.60596 50.1381 5.60596 49.1716V28.1813C5.60596 27.2148 6.38946 26.4313 7.35596 26.4313C8.32246 26.4313 9.10596 27.2148 9.10596 28.1813V47.4216H47.606V28.1716C47.606 27.2051 48.3895 26.4216 49.356 26.4216Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6185 25.7675C17.3019 25.0841 18.41 25.0841 19.0934 25.7675L28.356 35.0301L37.6185 25.7675C38.3019 25.0841 39.41 25.0841 40.0934 25.7675C40.7768 26.4509 40.7768 27.559 40.0934 28.2424L29.5934 38.7424C28.91 39.4258 27.8019 39.4258 27.1185 38.7424L16.6185 28.2424C15.9351 27.559 15.9351 26.4509 16.6185 25.7675Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3463 5.42163C29.3128 5.42163 30.0963 6.20513 30.0963 7.17163V37.505C30.0963 38.4715 29.3128 39.255 28.3463 39.255C27.3798 39.255 26.5963 38.4715 26.5963 37.505V7.17163C26.5963 6.20513 27.3798 5.42163 28.3463 5.42163Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.7b0e8399.svg";
export { ForwardRef as ReactComponent };